// extracted by mini-css-extract-plugin
export default {"Main":"Layout_Main__jlFtd","Header":"Layout_Header__cQxsT","Body":"Layout_Body__jBQGp","Sidebar":"Layout_Sidebar__YaM6T"};